import React, { useEffect, useState } from "react";
import PragaDossieDrawer from "../../praga-dossie-drawer";
import { openCulturaUrl } from "../../../utils/culturasPdf";

import Tooltip from "../../tooltip";
import api from "../../../services/api";
import { store } from "react-notifications-component";

import livro from "../../../assets/icons/icon-user-manual-gray.png";
import warning from "../../../assets/icons/warning-icon.svg";
import mira from "../../../assets/icons/icon-target-red.png";
import location from "../../../assets/icons/icon-pin-blue.png";
import iconClonar from "../../../assets/icons/icon-copy-gray.png";
import lixo from "../../../assets/icons/icon-trash-red.png";
import impressora from "../../../assets/icons/icon-print-gray.png";
import compartilhar from "../../../assets/icons/icon-share-gray.png";
import responsavel from "../../../assets/icons/icon-farmer-gray.png";
import redCircle from "../../../assets/icons/icon-red-circle.svg"

import StatusSuccess from "../../../assets/icons/status-3.png";
import StatusError from "../../../assets/icons/status-0.png";
import StatusPendent from "../../../assets/icons/status-1.png";
import StatusResend from "../../../assets/icons/status-1.png";

import Button from "../../button/button_v2";
import InputV3 from "../../input/novo/input_v3";
import ModalGeneric from "../../modal/modalGeneric";
import ModalConfirmar from "../../modal/modalConfirmar";
import LogoLoader from "../../LogoLoader";

import * as S from "./styles";
import { theme } from "../../../styles/theme";
import { BodyP, H5, H6, TaglineP } from "../../../styles/stylesTypography";
import HomologButtonHistory from "../homologButtonHistory";
import { isTotvs, isOmie } from "../../../services/globalFunctions";

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
const USER = JSON.parse(localStorage.getItem("@userinfo"));

const HistoryList = ({ history, onOpenGuia, ...props }) => {
  const [date, setDate] = useState([]);
  const [showModalEmail, setShowModalEmail] = useState(false);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [selectedReceitaId, setSelectedReceitaId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cancelText, setCancelText] = useState("");
  const [errorCancel, setErrorCancel] = useState("");
  const [historyList, setHistoryList] = useState(history);

  const [showModalConfirmar, setShowModalConfirmar] = useState(false);
  const [estadoClickReceita, setEstadoClickReceita] = useState(null);
  const [dossieOpen, setDossieOpen] = useState(false);
  const [dossie, setDossie] = useState({ id: null, name: "" });

  const submitEmail = async () => {
    try {
      if (!validateEmail(email)) {
        setErrorEmail("Email inválido");
        return;
      }
      const response = await api.post("/receitas/enviarReceita", {
        email: email,
        receita: selectedReceitaId,
      });
      if (response.status === 200) {
        setShowModalEmail(false);
        setIsLoading(false);
        setEmail("");
        setErrorEmail("");
        setIsTouched(false);

        store.addNotification({
          title: "Sucesso!",
          message: "A receita foi enviada com sucesso.",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
          },
        });
      }
    } catch (error) {
      setIsLoading(false);
      setShowModalEmail(false);

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }
  };

  const cancelarReceita = async (id, motivo) => {
    try {
      const response = await api.post(`/receitas/cancelar/${id}`, {
        motivo: motivo || "",
        reaproveitar: 1,
      });

      if (response.status === 200) {
        setShowModalCancel(false);
        setShowModalConfirmar(false);
        setCancelText("");
        setErrorCancel("");

        store.addNotification({
          title: "Sucesso!",
          message: "A receita foi cancelada com sucesso.",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
          },
        });

        const updatedHistory = history.map((item) =>
          item.id === id ? { ...item, status: 0 } : item
        );
        setHistoryList(updatedHistory);
      }

    } catch (error) {
      if (error.response.status === 400) {
        store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(error),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 7000,
            onScreen: true,
          },
        });
        return;
      }

      setShowModalCancel(false);
      setShowModalConfirmar(false);
      setCancelText("");
      setErrorCancel("");

      store.addNotification({
        title: "Erro!",
        message: "Erro ao cancelar a receita. Tente novamente.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }
  };

  const handleCancelReceita = async () => {
    try {
      if (cancelText !== "CANCELAR") {
        setErrorCancel('Digite "CANCELAR" para confirmar');
        return;
      }
      await cancelarReceita(selectedReceitaId, "");
    } catch (error) {
      // erro já tratado em cancelarReceita
    }
  };

  const respostaMt = async (resposta, motivo) => {
    if (resposta === 1 && selectedReceitaId) {
      await cancelarReceita(selectedReceitaId, motivo);
      modalClose();
    }
  };

  const resposta = async (resposta, idParam) => {
    if (resposta === 1) {
      const id = idParam || selectedReceitaId;
      await cancelarReceita(id, "");
      modalClose();
    }
  };

  const validateEmail = (email) => {
    if (!email || email === "") return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (isTouched) {
      setErrorEmail(validateEmail(e.target.value) ? "" : "Email inválido");
    }
  };

  const handleEmailBlur = () => {
    setIsTouched(true);
    setErrorEmail(validateEmail(email) ? "" : "Email inválido");
  };

  const handleShareClick = (receitaId) => {
    setSelectedReceitaId(receitaId);
    setShowModalEmail(true);
  };

  const handleCancelClick = (item) => {
    if (isTotvs() && item.nf) {
      store.addNotification({
        title: "Erro!",
        message:
          "Não é possível cancelar esta receita, pois a NF já foi emitida. Para cancelar esta receita, cancele a NF.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 7000,
          onScreen: true,
        },
      });
      return;
    }

    setSelectedReceitaId(item.id);
    setEstadoClickReceita(item.local_aplicacao_estado);
    if (item.local_aplicacao_estado === "MT" || item.local_aplicacao_estado === "ES") {
      setShowModalConfirmar(true);
    } else {
      setShowModalCancel(true);
    }
  };

  const handleModalClose = () => {
    setShowModalEmail(false);
    setEmail("");
    setErrorEmail("");
    setIsTouched(false);
  };

  const modalClose = () => {
    setShowModalEmail(false);
    setShowModalCancel(false);
    setShowModalConfirmar(false);
    setCancelText("");
    setErrorCancel("");
  };

  const handleCancelModalClose = () => {
    setShowModalCancel(false);
    setCancelText("");
    setErrorCancel("");
  };

  const handleCancelTextChange = (e) => {
    setCancelText(e.target.value);
    setErrorCancel("");
  };

  const clonar = (receita) => {

    const products = receita.produtos;
    const cultures = receita.culturas;
    const pests = receita.pragas;
    const aplications = receita.modos_aplicacoes;
    const doses = receita.dose;
    const numAplicacao = receita.numero_aplicacoes;
    const areas = receita.area_tratar;
    const quantidades = receita.quantidade_adquirir;

    let r = "";
    if (Array.isArray(receita.agro_prescriptions_relations)) {
      receita.agro_prescriptions_relations.forEach((rel) => {
        const idRel = rel?.fk_agro_relations_id;
        if (idRel !== undefined && idRel !== null) {
          r = r ? `${r};${idRel}` : `${idRel}`;
        }
      });
    }

    let prod = "";
    let c = "";
    let pst = "";
    let apl = "";
    let d = "";
    let n = "";
    let a = "";
    let q = "";

    if (Array.isArray(cultures)) {
      cultures.forEach((id) => { c = c ? `${c};${id}` : `${id}`; });
    }
    if (Array.isArray(products)) {
      products.forEach((id) => { prod = prod ? `${prod};${id}` : `${id}`; });
    }
    if (Array.isArray(pests)) {
      pests.forEach((id) => { pst = pst ? `${pst};${id}` : `${id}`; });
    }
    if (Array.isArray(aplications)) {
      aplications.forEach((id) => { apl = apl ? `${apl};${id}` : `${id}`; });
    }
    if (Array.isArray(doses)) {
      doses.forEach((id) => { d = d ? `${d};${id}` : `${id}`; });
    }
    if (Array.isArray(numAplicacao)) {
      numAplicacao.forEach((id) => { n = n ? `${n};${id}` : `${id}`; });
    }
    if (Array.isArray(areas)) {
      areas.forEach((id) => { a = a ? `${a};${id}` : `${id}`; });
    }
    if (Array.isArray(quantidades)) {
      quantidades.forEach((id) => { q = q ? `${q};${id}` : `${id}`; });
    }

    // Equipamento e texto livre e pode conter ';' ou '&', que sao justamente os
    // separadores desta URL - por isso cada nome vai codificado.
    // join, e nao o padrao "acumula se truthy" dos outros campos: equipamento e
    // opcional, e com aquele padrao um valor vazio no meio sumiria e deslocaria
    // todos os seguintes para a relacao errada.
    const eq = Array.isArray(receita.agro_prescriptions_relations)
      ? receita.agro_prescriptions_relations
          .map((rel) => encodeURIComponent(rel?.equipamento_aplicacao || ""))
          .join(";")
      : "";

    const finalURL = `/receitas/add/?cultures=${c}&pests=${pst}&products=${prod}&aplications=${apl}&relations=${r}&estado=${receita.local_aplicacao_estado}&dosages=${d}&numapli=${n}&areas=${a}&qtd=${q}&equipamentos=${eq}`;

    console.groupEnd();

    window.location.href = finalURL;
  };

  const getStatusHomologacao = (status) => {
    switch (status) {
      case 0:
        return "Bloqueado";
      case 1:
        return "Enviar hoje";
      case 2:
        return "Envio pendente";
      case 3:
        return "Enviado";
      case 4:
        return "Pendente urgente";
      default:
        return "Status desconhecido";
    }
  };

  useEffect(() => {
    if (history && history.length > 0) {
      const formattedDates = history.map((item) => {
        const date = new Date(item.data_emissao);
        const day = date.getUTCDate();
        const month = date
          .toLocaleString("pt-BR", { month: "short", timeZone: "UTC" })
          .toUpperCase()
          .replace(".", "");
        const year = date.getUTCFullYear();
        return `${day} ${month} ${year}`;
      });
      setDate(formattedDates);
    }
  }, [history]);

  useEffect(() => {
    setHistoryList(history);
  }, [history]);

  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {props.loading ? (
        <div
          style={{
            width: "100%",
            height: "calc(100vh - 21.05rem)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LogoLoader id="preLoader" color="#2FBB69" />
        </div>
      ) : (
        historyList.map((item, index) => (
          <S.Container key={index} disabled={item.status === 0}>
          <div className="wrapper">
            <S.PrimarySection disabled={item.status === 0}>
              {/* ====== CABEÇALHO: DATA + HOMOLOGAÇÃO + Nº RECEITA ====== */}
              <div className="headerGroup" style={{}}>
                <div className="date">
                  <TaglineP
                    color={
                      item.status === 0 ? "#AAAAAA" : theme.colors.gray.Cinza_2
                    }
                  >
                    {date[index]}
                  </TaglineP>

                  {/* ====== AÇÕES (ícones) ====== */}
                  {width > 760 && item.status !== 0 && <S.ContainerIcons>
                    <Tooltip
                      content={"Compartilhar"}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <img
                        src={compartilhar}
                        alt="Ícone de compartilhar"
                        onClick={() => handleShareClick(item.id)}
                      />
                    </Tooltip>

                    <Tooltip
                      content={"Imprimir"}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <img
                        src={impressora}
                        alt="Ícone de impressora"
                        onClick={() => window.open(item.receita_pdf, "_blank")}
                      />
                    </Tooltip>

                    {item.guias === 0 ? (
                      <Tooltip
                        content={"Gerar Guia"}
                        animation="fade"
                        delay={[0, 100]}
                        arrow
                        placement="bottom"
                      >
                        <img
                          src={livro}
                          alt="Ícone de livro"
                          onClick={() => onOpenGuia?.(item.id)}
                        />
                      </Tooltip>
                    ) : null}

                    <Tooltip
                      content={"Clonar Receita"}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <img
                        src={iconClonar}
                        alt="Ícone de clonar"
                        onClick={() => clonar(item)}
                      />
                    </Tooltip>

                    {!(isOmie() && item.nf) && (
                      <Tooltip
                        content={"Cancelar Receita"}
                        animation="fade"
                        delay={[0, 100]}
                        arrow
                        placement="bottom"
                      >
                        <img
                          src={lixo}
                          alt="Ícone de lixeira"
                          onClick={() => handleCancelClick(item)}
                        />
                      </Tooltip>
                    )}
                  </S.ContainerIcons>}
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  {item.status !== 0 && (item.local_aplicacao_estado === "GO" ||
                  item.local_aplicacao_estado === "DF" ||
                  item.local_aplicacao_estado === "MG" ||
                  item.local_aplicacao_estado === "SC" ||
                  item.local_aplicacao_estado === "BA" ||
                  item.local_aplicacao_estado === "ES" ||
                  (item.local_aplicacao_estado === "MT" &&
                    item.nu_receita !== "COMPLEMENTAR")) ? (
                    <HomologButtonHistory
                      key={item.id}
                      estado={item.local_aplicacao_estado}
                      nf={item.nf}
                      receitaId={item.id}
                      statusEnvio={parseInt(item.status_homologacao)}
                      updateReceitas={() => props.updateReceitas()}
                      propsLocation={props.propsLocation}
                      homologado={item.homologado}
                      homologacaoErro={item.homologacao_erro}
                      //Isso estava na development
                      // dataReceita={item.local_aplicacao_estado === "GO" ? item : null}
                      // O de baixo é do hotfix-id-receita
                      dataReceita={item}
                    />
                  ) : (null)}

                  <div className="numeroReceita">
                    <TaglineP
                      color={
                        item.status === 0
                          ? "#AAAAAA"
                          : theme.colors.gray.Cinza_2
                      }
                    >
                      RECEITA: {item.numero}
                    </TaglineP>
                  </div>
                </div>
              </div>

              {/* ====== LISTA DE PRODUTOS (produto + ingrediente + empresa + praga + hr juntos) ====== */}
              <div className="sectionOne">
                {item.nome_comercial.map((produto, i) => (
                  <React.Fragment key={i}>
                    <div className="productBlock">
                      <div
                        className="left"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.5rem",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <div className="product">
                          <H6
                            maxWidth="100%"
                            color={
                              item.status === 0
                                ? "#AAAAAA"
                                : theme.colors.gray.Cinza_2
                            }
                          >
                            {produto}
                          </H6>
                        </div>

                        <div className="ingredient">
                          <TaglineP
                            color={
                              item.status === 0
                                ? "#AAAAAA"
                                : theme.colors.gray.Cinza_2
                            }
                          >
                            {item.nome_tecnico[i]}
                          </TaglineP>
                        </div>
                      </div>

                      <div
                        className="right"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.5rem",
                          alignItems: "flex-end",
                          minWidth: "fit-content",
                        }}
                      >
                        <div className="empresa">
                          <BodyP
                            lineClamp="1"
                            color={
                              item.status === 0
                                ? "#AAAAAA"
                                : theme.colors.gray.Cinza_2
                            }
                          >
                            {item.fabricante[i]}
                          </BodyP>
                        </div>

                        <div className="pragaScroll">
                          <div
                            className="praga"
                            disabled={item.status === 0}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const pestId = Array.isArray(item.pragas) ? item.pragas[i] : null;
                              setDossie({ id: pestId, name: item.praga_nome_comum[i] });
                              setDossieOpen(true);
                            }}
                          >
                            <img src={mira} alt="Ícone de mira" style={{ width: "16px", height: "auto", flexShrink: 0 }}/>
                            <TaglineP
                              color={item.status === 0 ? "#FFFFFF" : `${theme.colors.red.Tostado}`}
                              fontWeight="800"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {item.praga_nome_comum[i]}
                            </TaglineP>
                          </div>
                        </div>
                      </div>
                    </div>

                    {i < item.nome_comercial.length - 1 && (
                      <hr className="full-width-line" />
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* ====== STATUS (CANCELADA) ====== */}
              <S.Badges disabled={item.status === 0}>
                <div className="badgeScroll">
                  <div className="produtor">
                    <Tooltip
                      content={`${item.id_externo && !isOmie() ? `${item.id_externo}: ` : ``}${item.produtor_nome}`}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <TaglineP color="#FFFFFF" fontWeight="800">
                        {item.id_externo && !isOmie() ? `${item.id_externo}: ` : ``}{item.produtor_nome}
                      </TaglineP>
                    </Tooltip>
                  </div>
                </div>

                <div className="badgeScroll">
                  <div className="farm">
                    <img src={location} alt="Ícone de localização" style={{ width: "16px", height: "16px" }}/>
                    <Tooltip
                      content={item.local_aplicacao_nome}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <TaglineP
                        color={theme.colors.blue.Azul_link}
                        fontWeight="800"
                      >
                        {item.local_aplicacao_nome}
                      </TaglineP>
                    </Tooltip>
                  </div>
                </div>

                <div
                  className="cultura"
                  style={{ cursor: "pointer" }}
                  onClick={() => openCulturaUrl(item.cultura_nome_comum)}
                >
                  <TaglineP color="#FFFFFF" fontWeight="800">
                    {item.cultura_nome_comum}
                  </TaglineP>
                </div>

                <div className="badgeScroll">
                  <div className="user">
                    <img src={responsavel} alt="Pessoa com chapéu" style={{ width: "16px", height: "auto" }}/>
                    <Tooltip
                      content={item.agronomo_nome}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <TaglineP
                        color={theme.colors.gray.Cinza_2}
                        fontWeight="800"
                      >
                        {item.agronomo_nome}
                      </TaglineP>
                    </Tooltip>
                  </div>
                </div>

                <S.ContainerNumeroArt>
                  <TaglineP color={item.status === 0 ? `${theme.colors.disabled.Desabilitado_Claro}` : "#21262F"} fontWeight="800">
                    {item.numero_art ? (
                      item.numero_art.includes("BR") ? (
                        `TRT: ${item.numero_art}`
                      ) : (
                        `ART: ${item.numero_art}`
                      )
                    ) : (
                      <></>
                    )}
                  </TaglineP>

                  {/* ====== AÇÕES (ícones) ====== */}
                  {width < 760 && item.status !== 0 && <S.ContainerIcons>
                    <Tooltip
                      content={"Compartilhar"}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <img
                        src={compartilhar}
                        alt="Ícone de compartilhar"
                        onClick={() => handleShareClick(item.id)}
                      />
                    </Tooltip>

                    <Tooltip
                      content={"Imprimir"}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <img
                        src={impressora}
                        alt="Ícone de impressora"
                        onClick={() => window.open(item.receita_pdf, "_blank")}
                      />
                    </Tooltip>

                    {item.guias === 0 ? (
                      <Tooltip
                        content={"Gerar Guia"}
                        animation="fade"
                        delay={[0, 100]}
                        arrow
                        placement="bottom"
                      >
                        <img
                          src={livro}
                          alt="Ícone de livro"
                          onClick={() => onOpenGuia?.(item.id)}
                        />
                      </Tooltip>
                    ) : null}

                    <Tooltip
                      content={"Clonar Receita"}
                      animation="fade"
                      delay={[0, 100]}
                      arrow
                      placement="bottom"
                    >
                      <img
                        src={iconClonar}
                        alt="Ícone de clonar"
                        onClick={() => clonar(item)}
                      />
                    </Tooltip>

                    {!(isOmie() && item.nf) && (
                      <Tooltip
                        content={"Cancelar Receita"}
                        animation="fade"
                        delay={[0, 100]}
                        arrow
                        placement="bottom"
                      >
                        <img
                          src={lixo}
                          alt="Ícone de lixeira"
                          onClick={() => handleCancelClick(item)}
                        />
                      </Tooltip>
                    )}
                  </S.ContainerIcons>}
                </S.ContainerNumeroArt>
              </S.Badges>
              {item.status === 0 ? (
                <div className="cancelado">
                  <div>
                    <img src={redCircle} alt="Ícone de cancelado" />
                  <TaglineP color={theme.colors.red.Tostado} fontWeight="600">
                    Cancelada
                  </TaglineP>
                  </div>
                </div>
              ) : null}
            </S.PrimarySection>
          </div>
        </S.Container>
      )))}

      {/* ====== DRAWER: DOSSIÊ DE PRAGA ====== */}
      <PragaDossieDrawer
        pestId={dossie.id}
        pestName={dossie.name}
        isOpen={dossieOpen}
        onClose={() => setDossieOpen(false)}
      />

      {/* ====== MODAIS (inalterados) ====== */}
      <ModalGeneric show={showModalEmail} onHide={handleModalClose}>
        <H5 style={{ marginBottom: "20px" }}>Enviar receita por Email</H5>
        <InputV3
          id="email"
          placeholder="Digite o email"
          value={email}
          hasError={isTouched && !validateEmail(email)}
          label="Email"
          floatingLabel="Email"
          errorInfo={errorEmail}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
        />
        <Button
          onClick={() => {
            submitEmail();
            setIsLoading(true);
          }}
          disabled={!validateEmail(email)}
          width="100%"
          height="40px"
          value="Enviar"
          loading={isLoading}
          style={{ marginTop: "20px" }}
        />
      </ModalGeneric>

      <ModalGeneric show={showModalCancel} onHide={handleCancelModalClose}>
        <H5 style={{ marginBottom: "20px" }}>Cancelar Receita</H5>
        <BodyP style={{ marginBottom: "20px" }}>
          Digite 'CANCELAR' para continuar o cancelamento da receita
        </BodyP>
        <InputV3
          placeholder="Digite 'CANCELAR' para confirmar"
          value={cancelText}
          hasError={errorCancel !== ""}
          label="Confirmação"
          floatingLabel="Confirmação"
          errorInfo={errorCancel}
          onChange={handleCancelTextChange}
        />
        <Button
          onClick={handleCancelReceita}
          disabled={cancelText !== "CANCELAR"}
          width="100%"
          height="48px"
          value="Confirmar Cancelamento"
          style={{ marginTop: "20px" }}
        />
      </ModalGeneric>

      <ModalConfirmar
        show={showModalConfirmar}
        estado={estadoClickReceita}
        text="Digite 'CANCELAR' para continuar o cancelamento da receita"
        title="Confirmar Cancelamento de Receita"
        id={selectedReceitaId}
        update={resposta}
        updateMt={(r, motivo) => respostaMt(r, motivo)}
        onHide={modalClose}
      />
    </>
  );
};

export default HistoryList;
